import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box } from "@mui/material";
import { TableLoadingSkeleton } from "src/shared/components/tables/table-loading-skeleton";
import { NoData } from "src/shared/components/tables/no-data";
import TableActions from "./table-actions";
import { useTranslation } from "react-i18next";
import { formatNumber } from "src/utils";
import TableHeadText from "src/shared/components/table-head";

const ProductSalesTable = ({
  rows,
  isLoading,
}: {
  rows: any;
  isLoading: boolean;
}) => {
  const emptyDataArr = rows?.length === 0;
  const { t: salesT } = useTranslation("addSales");
  const { t: generalT } = useTranslation("general");
  const HeadText = [
    generalT("reference"),
    generalT("branch"),
    generalT("period"),
    salesT("productSales"),
    salesT("totalCost"),
    `${generalT("cogs")} %`,
    generalT("actions"),
  ];

  return (
    <Box overflow={"auto"} maxWidth={{ xs: "100%", md: `calc(100vw - 316px)` }}>
      <TableContainer component={Paper} variant="outlined">
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              {HeadText.map((item) => (
                <TableCell
                  key={item}
                  align="center"
                  sx={{ bgcolor: "#F9FAFB" }}
                >
                  <TableHeadText text={item} />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {isLoading ? (
            <TableLoadingSkeleton rowsLength={5} cellsLength={7} />
          ) : (
            <TableBody>
              {rows?.map((row: any) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center"> {row.reference}</TableCell>
                  <TableCell align="center">{row.branch_name}</TableCell>
                  <TableCell align="center" sx={{ minWidth: "115px" }}>
                    {row.start_date} {row.end_date}
                  </TableCell>
                  <TableCell align="center">
                    {formatNumber(row.sales)}
                  </TableCell>
                  <TableCell align="center">{formatNumber(row.cost)}</TableCell>
                  <TableCell align="center">
                    %{row.cogs}
                  </TableCell>
                  <TableCell align="center">
                    <TableActions rowId={row.id} rowRef={row.reference} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
        {emptyDataArr && <NoData />}
      </TableContainer>
    </Box>
  );
};
export default ProductSalesTable;
